/**
 * Envía la anécdota del aficionado a la API.
 * @param {Object} dataPayload - Objeto con la información { content, sender }
 * @returns {Promise<{success: boolean, data?: any, message?: string}>}
 */
const SendMessage = async (dataPayload) => {
    try {
        const requestBody = {
            content: dataPayload.content,
            sender: dataPayload.sender
        };

        const response = await fetch(process.env.REACT_APP_API_URL + "anecdotes/send", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody)
        });

        // Verificamos si la respuesta HTTP no fue exitosa (ej: 400, 500)
        if (!response.ok) {
            const errorData = await response.json();
            return {
                success: false,
                message: errorData.message || 'No ha sido posible enviar tu anécdota. Inténtalo nuevamente.'
            };
        }

        const responseData = await response.json();

        // Retorno exitoso
        return { success: true, data: responseData };

    } catch (error) {
        // Error de red o conexión
        return {
            success: false,
            message: 'Error de conexión. Por favor revisa tu internet e inténtalo de nuevo.'
        };
    }
};

export { SendMessage };
